// require("./lib/ads");
// var track = require("./lib/tracking");

// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(11383531), 3000);

var playerInstance;


// var loadBC = require("./brightcove");
var $ = require("./lib/qsa");

require("./form");
var wire = require("./wire");


var { stories, feelings } = window.playlistData;

console.log(stories);

// player is loaded async, so here's a dummy version
var player = {
  play: () => {},
  pause: () => {},
  pending: null
};

var playFeeling = function(f) {


  // if (!player.catalog) {
  //   return player.pending = f;
  // }

  var matching = stories.filter(row => row.feelings.indexOf(f) > -1);

  // always show a new video if possible
  if (state.video) {
    var unplayed = matching.filter(row => !(row.id in state.played));
    if (unplayed.length) matching = unplayed;
  }


  var index = Math.random() * matching.length | 0;
  var choice = matching[index];

  console.log(choice);

  // player.catalog.getVideo(choice.id, function(err, result) {
  //   player.catalog.load(result);
  playerInstance = jwplayer('videoPlayer').setup({
  playlist: `https://cdn.jwplayer.com/v2/media/${choice.id}`,
  "mute": false,
  }).play();

    state.set({
      video: choice,
      overlay: false,
      mode: "experience"
    });
    state.set(`played.${choice.id}`, true);
    // player.play();
  // });


};

// wire up the UI to the state object
var state = wire($.one(".app"), {
  mode: "intro",
  feeling: feelings[0],
  played: {},
  onStep: function() {
    var inc = this.classList.contains("next") ? 1 : -1;
    var current = state.feeling;
    var index = feelings.indexOf(current);
    index = (index + inc) % feelings.length;
    if (index < 0) index = feelings.length - 1;
    state.set("feeling", feelings[index]);
  },
  showHelp: function() {
    // player.pause();
    if (playerInstance){ playerInstance.pause(); }
    state.set("mode", "help");
  },
  showVideo: function() {
    playFeeling(state.feeling);
  },
  onChange: function() {
    state.set("feeling", this.value);
    playFeeling(state.feeling);
  },
  closeAll: function() {
    if (playerInstance){ playerInstance.pause(); }
    // player.pause();
    state.set("mode", "intro");
  },
  closeOverlay: function() {
    state.set("overlay", false);
    player.play();
  }
});



// load the actual Brightcove code, which can take a while
// loadBC($.one(".brightcove"), function(p) {
//
//   var facade = player;
//   player = p;
//   if (facade.pending) playFeeling(facade.pending);
//
//   player.on("pause", function(e) {
//     if (player.seeking()) return;
//     state.set("overlay", true);
//   });
//
// });
